import { MenuComponent } from './../components/menu/menu.component';
import { CustomMenuItemDetailComponent } from './../components/menu/custom-menu-item-detail.component';
import { ConfirmationComponent } from './../shared/components/modal/confirmation/confirmation.component';

export const menuRoutes = {
    path: 'menu',
    component: MenuComponent,
    data: {
        breadcrumbs: {
            label: 'Menu',
            icon: 'menu'
        },
        state: 'menu'
    },
    children: [
        {
            path: 'custom/:lang',
            component: CustomMenuItemDetailComponent,
            data: {
                breadcrumbs: {
                    label: 'Přidat vlastní položku menu'
                },
                state: 'custom-menu-items-add'
            },
            outlet: 'modal'
        },
        {
            path: 'custom-delete/:id',
            component: ConfirmationComponent,
            data: {
                breadcrumbs: {
                    label: 'Smazat položku'
                },
                state: 'custom-delete',
                apiUri: 'custom-menu-items'
            },
            outlet: 'modal'
        }
    ]
};
